import { useState, type JSX } from 'react';
import { FlaskConical } from 'lucide-react';
import { type TrialDto } from '@ctms/contracts';

import { TrialCard } from './trial-card/trial-card.js';
import { TrialCatalog } from './trial-catalog/trial-catalog.js';

export interface TrialsViewProps {
  canRead: boolean;
  canWrite: boolean;
  canWritePersonnel: boolean;
  isTenantAdmin: boolean;
}

export function TrialsView({
  canRead,
  canWrite,
  canWritePersonnel,
  isTenantAdmin,
}: TrialsViewProps): JSX.Element {
  const [openedTrial, setOpenedTrial] = useState<TrialDto | null>(null);

  if (openedTrial) {
    return (
      <TrialCard
        seed={openedTrial}
        canWrite={canWrite}
        canWritePersonnel={canWritePersonnel}
        onBack={() => setOpenedTrial(null)}
      />
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 border-b border-slate-800 pb-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-cyan-950 text-cyan-400 ring-1 ring-cyan-800">
          <FlaskConical className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-slate-100">Badania w ośrodku</h2>
          <p className="text-xs text-slate-400">
            Lista robocza pokazuje wyłącznie badania aktywne. Nieaktywne nie wchodzą do codziennego wyboru.
          </p>
        </div>
      </div>
      <TrialCatalog
        canRead={canRead}
        canWrite={canWrite}
        isTenantAdmin={isTenantAdmin}
        onOpenTrial={setOpenedTrial}
      />
    </div>
  );
}
